import { findNodeInRange, isElement } from './dom/node';

export function isImageElement(node: Node): node is HTMLImageElement {
  return isElement(node) && node.tagName === 'IMG';
}

export function findImageInRange(container: Node, range: Range): HTMLImageElement | null {
  return findNodeInRange(container, range, isImageElement);
}
